export const identity = <T>(a: T) => a;
